import angular from 'angular';

angular
  .module('cloudX')
  .controller('CreateUserProfileDialogCtrl', [
    '$element',
    '$q',
    'flySvc',
    'close',
    'employee',
    'save',
    createUserProfileDialogCtrl,
  ]);

function createUserProfileDialogCtrl($element, $q, flySvc, close, employee, save) {
  var vm = this;

  vm.employee = employee;
  vm.data = {
    userEmail: employee.employeeEmail || '',
    userEnabled: true,
    userLanguage: 'nl',
    userTravelFromHome: false,
    userTravelOneWay: false,
  };

  vm.save = function() {
    vm.data.userRoles = vm.data.userRole !== null ? [vm.data.userRole] : [];

    $q.when(save(vm.data)).then(
      function(result) {
        close(result, 500);
        $element.modal('hide');
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
      },
    );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
